import { UAParser } from 'ua-parser-js'

export function init(params) {
  return new Promise((resolve, reject) => {
    function onBridgeReady() {
      try {
        // window.ToPayJSBridge.init 二次调用native的init方法会抛异常
        window.ToPayJSBridge.init(function(message, responseCallback) {})
      } catch (error) {
        console.log(error)
        // return reject(new Error('JSBridge: Bridge init failed'))
      }
      return resolve()
    }

    // 判断全局的Bridge对象，存在即直接调用，不存在则监听回调事件
    console.log(typeof ToPayJSBridge)
    if (typeof ToPayJSBridge === 'undefined') {
      document.addEventListener('ToPayJSBridgeReady', onBridgeReady, false) // ToPayJSBridgeReady
    } else {
      onBridgeReady()
    }
  })
}

export function recordEvent(data) {
  // appsFlyer数据埋点
  init().then((res) => {
    window.ToPayJSBridge.invoke('recordEvent', data)
  })
}

export function openNative(url, needCallBack, callback) {
  // h5打开native原生功能
  if (url.indexOf('native/kyc/') !== -1) {
    // kyc添加source参数，兼容2.10版本
    // "params=json串"，Android encode处理（兼容老版本），iOS直接传入
    const OSName = new UAParser().getOS().name
    if (OSName === 'Android') {
      url = `${url}?${encodeURIComponent(
        `params={"source": "${window.location.pathname}"}`
      )}`
    } else {
      url = `${url}?params={"source": "${window.location.pathname}"}`
    }
  }
  console.log(url, needCallBack)
  init().then((res) => {
    window.ToPayJSBridge.invoke(
      'openNative',
      { router: url, needCallback: needCallBack || false },
      function(data) {
        const res = JSON.parse(data)
        console.log(res)
        typeof callback === 'function' && callback(res)
      }
    )
  })
}

export function openNewUrl(url) {
  // h5打开新的webview, android使用openNewUrl, IOS使用openNative
  init().then((res) => {
    const OSName = new UAParser().getOS().name
    if (OSName === 'Android') {
      window.ToPayJSBridge.invoke('openNewUrl', { url })
    } else {
      openNative(url)
    }
  })
}

export function openPayByOfficialChat() {
  const OSName = new UAParser().getOS().name
  if (OSName === 'Android') {
    openNative('route://native/cms/messageCenter')
  } else {
    openNative('route://native/cms/messageList')
  }
}

export function openByBrowser(url) {
  // 用浏览器打开
  init().then((res) => {
    window.ToPayJSBridge.invoke('openByBrowser', { url })
  })
}
